"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const StyledGraphic_1 = require("components/Dashboard/StyledGraphic");
const noApiKeys_webp_1 = __importDefault(require("assets/images/dashboard/noApiKeys.webp"));
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const accountCopy_1 = require("copy/accountCopy");
const StyledGreyText_1 = require("components/Dashboard/StyledGreyText");
const react_bootstrap_1 = require("react-bootstrap");
const SensitiveData_1 = __importDefault(require("./SensitiveData"));
const CreateKeyForm_1 = __importDefault(require("./CreateKeyForm"));
const Spacer_1 = require("components/Dashboard/Spacer");
const StyledFeatherIcon_1 = require("components/general/StyledFeatherIcon");
const StyledHover_1 = require("components/Dashboard/StyledHover");
const config_1 = require("assets/styles/config");
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const SimpleTable_1 = __importStar(require("components/Dashboard/SimpleTable"));
const DateFormat_1 = require("components/general/utility/DateFormat");
const react_2 = require("react");
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const SimpleModal_1 = __importDefault(require("components/Dashboard/SimpleModal"));
const MalomoText_1 = require("components/Dashboard/MalomoText");
const publishable = 'publishable';
const secret = 'secret';
const DeveloperUI = ({ handleCreate, handleDelete, hasError, loading, publicApiKeys, secretApiKeys }) => {
    const hasPublicKeys = () => publicApiKeys && (0, SimpleTable_1.hasSimpleTableViewableRecords)(publicApiKeys);
    const hasSecretKeys = () => secretApiKeys && (0, SimpleTable_1.hasSimpleTableViewableRecords)(secretApiKeys);
    const hasAnyKeys = () => hasPublicKeys() || hasSecretKeys();
    const [showDeleteModal, setShowDeleteModal] = (0, react_2.useState)(false);
    const [focusedKey, setFocusedKey] = (0, react_2.useState)(null);
    const handleClickDeleteIcon = (key) => {
        setFocusedKey(key);
        setShowDeleteModal(true);
    };
    function hideDeleteModal() {
        setFocusedKey(null);
        setShowDeleteModal(false);
    }
    function performDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield handleDelete(focusedKey);
            hideDeleteModal();
        });
    }
    const renderNoKeys = () => (react_1.default.createElement("div", { className: 'col-auto' },
        react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, { height: '315px' },
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: '', src: noApiKeys_webp_1.default }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, accountCopy_1.developerCopy.noApiKeysYet),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { role: 'paragraph' }, accountCopy_1.developerCopy.noApiKeysYetExplainer))));
    const headerEntries = [
        { name: 'Label' },
        { name: 'API Key', width: '40%' },
        { name: 'Created On' },
        { name: '', width: '10%' }
    ];
    const tableBody = (keys, type) => {
        let prefix = '';
        if (type === secret) {
            prefix = 'sk_';
        }
        else if (type === publishable) {
            prefix = 'pk_';
        }
        else {
            throw new Error(`Unknwon key type: ${type}`);
        }
        return keys.map((key) => {
            return {
                key: key.id,
                shouldShow: key.shouldShow,
                entries: [
                    { content: key.name },
                    {
                        content: react_1.default.createElement(SensitiveData_1.default, { data: `${prefix}${key.token}` }),
                        width: '40%'
                    },
                    { content: (0, DateFormat_1.twoDigitDateFormat)(key.insertedAt) },
                    {
                        content: (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(StyledHover_1.StyledHover, { defaultColor: config_1.colors.blurple, hoverColor: config_1.colors.indigo, pointer: true }, react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-trash-2', onClick: () => handleClickDeleteIcon(key) })))),
                        width: '10%'
                    }
                ]
            };
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
            react_1.default.createElement("div", { className: 'row align-items-center justify-content-center', style: { paddingTop: '28px' } },
                react_1.default.createElement(SimpleModal_1.default, { body: react_1.default.createElement(MalomoText_1.MalomoText, { paragraph: true, small: true }, "You will be unable to make API requests with this key once deleted."), display: showDeleteModal, header: 'Delete API Key', onToggleModal: hideDeleteModal, primaryButton: react_1.default.createElement(MalomoButton_1.MalomoButton, { onClick: performDelete }, "Delete") }),
                react_1.default.createElement(Spacer_1.Spacer, { margin: { bottom: '28px' } },
                    react_1.default.createElement(CreateKeyForm_1.default, { onCreate: handleCreate })),
                hasError && (react_1.default.createElement(MalomoText_1.MalomoText, null, "Uh-oh, there was a problem. Please reload the page.")),
                loading && react_1.default.createElement(LoadingSpinner_1.default, null),
                react_1.default.createElement(react_bootstrap_1.Fade, { in: !loading && !hasError },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_bootstrap_1.Fade, { in: !hasAnyKeys() }, !hasAnyKeys() ? renderNoKeys() : react_1.default.createElement("div", null)),
                        react_1.default.createElement(react_bootstrap_1.Fade, { in: hasPublicKeys(), unmountOnExit: true }, hasPublicKeys() ? (react_1.default.createElement("div", null,
                            react_1.default.createElement(SimpleTable_1.default, { body: tableBody(publicApiKeys, publishable), headers: headerEntries, margin: '0 0 20px', title: 'Publishable Keys' }))) : (react_1.default.createElement("div", null))),
                        react_1.default.createElement(react_bootstrap_1.Fade, { in: hasSecretKeys(), unmountOnExit: true }, hasSecretKeys() ? (react_1.default.createElement("div", null,
                            react_1.default.createElement(SimpleTable_1.default, { body: tableBody(secretApiKeys, secret), headers: headerEntries, margin: '0 0 20px', title: 'Secret Keys' }))) : (react_1.default.createElement("div", null)))))))));
};
exports.default = DeveloperUI;
